/**
 * ReserveSiteLauncher
 *
 * Le CTA flottant bas de page a été retiré volontairement.
 * Forfeo Reserve est maintenant accessible par l’icône compacte du header.
 */
export default function ReserveSiteLauncher() {
  return null;
}
